import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../Card';
import { fmtPct, fmtUsd } from './format';

interface Props {
  label: string;
  tierBudgetUsd: number;
  tierDeployedUsd: number;
  tierAvailableUsd: number;
  allocationPct?: number;
  extra?: React.ReactNode;
}

const TierBudgetCard: React.FC<Props> = ({
  label,
  tierBudgetUsd,
  tierDeployedUsd,
  tierAvailableUsd,
  allocationPct,
  extra,
}) => {
  const utilPct =
    tierBudgetUsd > 0 ? (tierDeployedUsd / tierBudgetUsd) * 100 : 0;

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-gray-500">{label} budget</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-xl font-semibold">{fmtUsd(tierBudgetUsd)}</p>
          {allocationPct != null ? (
            <p className="text-xs text-gray-500">{fmtPct(allocationPct * 100)} of deployable</p>
          ) : null}
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-gray-500">Deployed</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-xl font-semibold">{fmtUsd(tierDeployedUsd)}</p>
          <p className="text-xs text-gray-500">{fmtPct(utilPct)} utilized</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-gray-500">Available</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-xl font-semibold">{fmtUsd(tierAvailableUsd)}</p>
        </CardContent>
      </Card>
      {extra ? (
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-gray-500">Status</CardTitle>
          </CardHeader>
          <CardContent>{extra}</CardContent>
        </Card>
      ) : null}
    </div>
  );
};

export default TierBudgetCard;
